export function register(positioners) {
    Object.keys(positioners).forEach(key => {
        const previous = positioners[key]

        positioners[key] = function (elements, eventPosition) {
            const tooltip = this

            const { height: tooltipHeight } = tooltip._view
            const { height: chartHeight } = tooltip._chartInstance

            const result = previous(elements, eventPosition)

            if (result.y < tooltipHeight) {
                result.y = tooltipHeight + 8
            } else if (result.y > chartHeight) {
                result.y = chartHeight - 8
            }

            return result
        }
    })
}
